import type {
    InboxWorkflowCellContext,
    InboxWorkflowSelectOption,
} from "@kontextwerk/control-web-frame/shared/logic/inbox-workflow"
import { propertyCustomerRoleOptions } from "../../../../../../../../../../../_shared/_logic/customer-roles"
import { compactInboxCustomerToggleLabel } from "../../../../../_shared/_logic/cells-presentation"
import type {
  AssignRequesterCustomerDraft,
  AssignRequesterCustomerRow,
  RequesterCustomerCandidate,
} from "../contract"

const existingPrefix = "existing:"

export const requesterCustomerRoleOptions = (): InboxWorkflowSelectOption[] => [
  { value: "", label: "Rolle auswählen" },
  ...propertyCustomerRoleOptions.map((option) => ({ value: option.value, label: option.name })),
]

export const requesterCustomerDecisionValue = ({
  draft,
}: InboxWorkflowCellContext<AssignRequesterCustomerRow, AssignRequesterCustomerDraft>) =>
  draft.decision === "use_existing" && draft.customerId
    ? `${existingPrefix}${draft.customerId}`
    : draft.decision

const selectedCandidate = (
  row: AssignRequesterCustomerRow,
  value: string,
): RequesterCustomerCandidate | null => {
  const customerId = value.startsWith(existingPrefix) ? value.slice(existingPrefix.length) : ""

  return customerId
    ? (row.customerOptions.find((candidate) => candidate.customerId === customerId) ?? null)
    : null
}

export const requesterCustomerDecisionPatch = (
  value: unknown,
  { row }: InboxWorkflowCellContext<AssignRequesterCustomerRow, AssignRequesterCustomerDraft>,
): Partial<AssignRequesterCustomerDraft> => {
  const selected = selectedCandidate(row, String(value ?? ""))

  if (!selected) return { decision: "create_new", customerId: null }

  return {
    decision: "use_existing",
    customerId: selected.customerId,
    role: selected.role,
    email: selected.email,
    phone: selected.phone,
  }
}

export const requesterCustomerDecisionOptions = ({
  row,
}: InboxWorkflowCellContext<
  AssignRequesterCustomerRow,
  AssignRequesterCustomerDraft
>): InboxWorkflowSelectOption[] => [
  {
    value: "create_new",
    label: "Neu anlegen",
    tooltipContent: "Gemeldeten Ansprechpartner neu anlegen und Kontaktmittel übernehmen.",
  },
  ...row.customerOptions.map((candidate) => ({
    value: `${existingPrefix}${candidate.customerId}`,
    label: `${compactInboxCustomerToggleLabel(candidate.displayName)} zuordnen`,
    tooltipContent:
      [candidate.displayName, candidate.role, candidate.email, candidate.phone]
        .filter(Boolean)
        .join(" · ") || "Gemeldeten Ansprechpartner diesem bestehenden Ansprechpartner zuordnen.",
  })),
]
